<template>
  <div style="background-color: #fff; width: 100%; padding: 20px;">
    <a-layout style="background-color: black">
      <a-layout>
        <div class="mask warning" v-show="isAddOrEdit">
          <div style=" position: absolute; top: 5px; right: 10px; cursor: pointer;" @click="cancel">
            <a-icon type="close" style="color: #fff; font-size: 24px;" />
          </div>
          <a-spin size="large" class="spin" v-show="isLoading"></a-spin>
          <div v-show="!isLoading">
            <div class="device">
              <div class="f">
                <h3 class="head">
                  {{ $t('station.LLJ') }}
                </h3>
                <div class="border"></div>
                <div class="body">
                  <ul>
                    <li 
                      v-for="item in flowmeterList"
                      :key="item.code"
                      :title="item.name.length > 9 ? item.name : ''"
                    >
                      <span :title="item.name" class="device_name">{{ item.name.slice(0, 9) }}</span>
                      <input 
                        type="checkbox"
                        :checked="item.checked"
                        @change="oncheckedChange($event, item)"
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="e">
                <h3 class="head">
                  {{ $t('station.DB') }}
                </h3>
                <div class="border"></div>
                <div class="body">
                  <ul>
                    <li 
                      v-for="item in elctricityMeterList"
                      :key="item.code"
                      :title="item.name.length > 9 ? item.name : ''"
                    >
                      <span :title="item.name" class="device_name">{{ item.name.slice(0, 9) }}</span>
                      <input 
                        type="checkbox"
                        :checked="item.checked"
                        @change="oncheckedChange($event, item)"
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <a-form-model layout="inline">
              <a-form-model-item :label="$t('warningForm.template')">
                <a-select :placeholder="$t('warningForm.st')" dropdownClassName="selectOption" style="width: 280px" v-model="model" @change="handleModelChange">
                  <a-select-option value="-">
                    {{ $t('warningForm.none') }}
                  </a-select-option>
                  <a-select-option v-for="w in warningTemplateList" :key="w.id" :value="w.id">
                    {{ w.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item>
                <a-button type="primary" v-show="isDelBtnShow" @click="delTemplate">{{ $t('warningForm.delete') }}</a-button>
              </a-form-model-item>
            </a-form-model>
            <a-form-model layout="inline" :model="form1" :rules="rules" ref="form1">
              <a-form-model-item :label="$t('device.warningName')" style="margin-right: 60px;" prop="name">
                <a-input v-model="form1.name" :placeholder="$t('warningForm.swmn')" style="width: 240px" />
              </a-form-model-item>
              <a-form-model-item :label="$t('device.warningType')" required style="margin-right: 60px;">
                <a-select :placeholder="$t('warning.swt')" value="1" dropdownClassName="selectOption" style="width: 200px" >
                  <a-select-option value="1">
                    {{ $t('warningForm.ratioWarning') }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('warningForm.strategyConstraint')" prop="strategyConstraint" style="margin-right: 60px;">
                <a-select :placeholder="$t('warningForm.sct')" v-model="form1.strategyConstraint" dropdownClassName="selectOption" style="width: 200px">
                  <a-select-option value="AND">
                    {{ $t('warningForm.and') }}
                  </a-select-option>
                  <a-select-option value="OR">
                    {{ $t('warningForm.or') }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('menu.enabled')">
                <a-switch v-model="form1.enabled" :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" style="margin-top: 5px;" />
              </a-form-model-item>
            </a-form-model>
            <a-form-model :model="form2" ref="form2" :rules="rules">
              <a-form-model-item :label="$t('device.content')"  prop="noticeContent">
                <a-input v-model="form2.noticeContent" :placeholder="$t('warningForm.encn')"></a-input>
              </a-form-model-item>
            </a-form-model>
            <a-form-model class="flex" :model="form3" :rules="rules" ref="form3">
              <a-form-model-item :label="$t('warningForm.noticeFrequency')" prop="noticeFrequency">
                <a-select v-model="form3.noticeFrequency" :placeholder="$t('warningForm.snf')" dropdownClassName="selectOption">
                  <a-select-option :value="1">
                    1
                  </a-select-option>
                  <a-select-option :value="3">
                    3
                  </a-select-option>
                  <a-select-option :value="6">
                    6
                  </a-select-option>
                  <a-select-option :value="12">
                    12
                  </a-select-option>
                  <a-select-option :value="24">
                    24
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('warningForm.warningLevel')" prop="warningLevel">
                <a-select v-model="form3.warningLevel" :placeholder="$t('warningForm.swl')" dropdownClassName="selectOption">
                  <a-select-option value="URGENT">
                    {{ $t('warningForm.URGENT') }}
                  </a-select-option>
                  <a-select-option value="IMPORTANT">
                    {{ $t('warningForm.IMPORTANT') }}
                  </a-select-option>
                  <a-select-option value="MINOR">
                    {{ $t('warningForm.MINOR') }}
                  </a-select-option>
                  <a-select-option value="PROMPT">
                    {{ $t('warningForm.PROMPT') }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('warningForm.effectiveTime')" required>
                <a-time-picker v-model="startTime" format="HH:mm"/>
                <span style="color: #fff; margin: 0 15px;">-</span>
                <a-time-picker v-model="endTime" format="HH:mm" />
              </a-form-model-item>
            </a-form-model>
            <a-form-model class="flex" :model="form3">
              <a-form-model-item :label="$t('warningForm.noticeCnt')" required>
                <a-input-number v-model="form3.noticeCnt" style="width: 80%;" />
              </a-form-model-item>
              <a-form-model-item :label="$t('warningForm.recoveryNotice')">
                <a-switch v-model="form3.recoveryNotice" :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" />
              </a-form-model-item>
              <div style="width: 96%;"></div>
            </a-form-model>
            <a-form-model :model="form4" :rules="rules" ref="form4">
              <!-- <a-form-model-item label="通知手机号" :required="!isDelBtnShow">
                <a-button type="primary" style="margin-bottom: 20px;" @click="addMobile">添加通知手机号</a-button>
                <div class="ant-col ant-form-item-control-wrapper" v-for="(i, index) in mobiles" :key="index" style="margin-bottom: 15px">
                  <div class="wrapper">
                    <a-select option-label-prop="label" @focus="recordMobileIndex(index)" v-model="mobiles[index].reference" @select="handleSelectUsers" notFoundContent="暂无联系人" :getPopupContainer="(triggerNode) => triggerNode.parentNode" placeholder="请选择联系人" dropdownClassName="selectOption">
                      <a-select-option v-for="u in users" :key="u.id" :value="JSON.stringify([u.realName, u.username, u.organizationName])" :label="u.realName">
                        {{ u.realName }} - {{ u.username }} {{ u.organizationName ? '-' + u.organizationName : '' }}
                      </a-select-option>
                    </a-select>
                    <div style="margin: -4px 30px 0" class="ant-form-item-control" :class="{'has-error': i.error}">
                      <span class="ant-form-item-children">
                        <input data-v-30231798="" v-model="mobiles[index].mobile" placeholder="请输入通知手机号" type="text" class="ant-input" @blur="validate(i)">
                      </span>
                      <div class="ant-form-explain" style="white-space: nowrap; position: absolute" v-show="i.error">请输入通知手机号</div>
                    </div>
                    <a-input placeholder="请输入组织" v-model="mobiles[index].organizationName" style="width: 30%; margin-right: 30px" />
                    <div class="ant-form-item-control">
                      <label>是否接收短信：</label>
                      <a-switch v-model="mobiles[index].smsEnabled" />
                    </div>
                    <el-button type="primary" icon="el-icon-delete" circle style="position: relative; right: 160px" :disabled="mobiles.length === 1" @click="mobiles.splice(index, 1)" />
                  </div>
                </div>
              </a-form-model-item> -->
              <a-form-model-item :label="$t('warningForm.warningRepeat')" prop="warningRepeat">
                <a-select v-model="form4.warningRepeat" mode="tags" style="width: 100%; color: #fff" :placeholder="$t('warningForm.swr')" dropdownClassName="selectOption">
                  <a-select-option value="1">{{ $t('warningForm.Sunday') }}</a-select-option>
                  <a-select-option value="2">{{ $t('warningForm.Monday') }}</a-select-option>
                  <a-select-option value="3">{{ $t('warningForm.Tuesday') }}</a-select-option>
                  <a-select-option value="4">{{ $t('warningForm.Wednesday') }}</a-select-option>
                  <a-select-option value="5">{{ $t('warningForm.Thursday') }}</a-select-option>
                  <a-select-option value="6">{{ $t('warningForm.Friday') }}</a-select-option>
                  <a-select-option value="7">{{ $t('warningForm.Saturday') }}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('warningForm.description')" prop="description">
                <a-input :placeholder="$t('warningForm.ed')" v-model="form4.description" style="padding: 0 10px; color: #fff" />
              </a-form-model-item>
              <div>
                <h3 class="tableTitle">{{ $t('warningForm.judgeCondition') }}: </h3>
                <a-button type="primary" @click="addFormTableItem">{{ $t('warningForm.addCondition') }}</a-button>
                <!-- <a-button v-show="deviceTableList.judgeList.length > 1" type="primary" icon="undo" style="margin-left: 20px;" @click="undoData">撤销</a-button> -->
                <table class="formTable">
                  <thead>
                    <tr>
                      <th>{{ $t('warningForm.judge') }}</th>
                      <th>{{ $t('warningForm.valueType') }}</th>
                      <th>{{ $t('warningForm.value') }}</th>
                      <th>{{ $t('warningForm.monitorTime') }}</th>
                      <th>{{ $t('warningForm.duration') }}</th>
                      <th>{{ $t('common.operation') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(dataTableItem, index) in deviceTableList.judgeList" :key="dataTableItem.id">
                      <td style="position: relative;">
                        <a-input :placeholder="$t('warningForm.judge')" readOnly v-model="deviceTableList.judgeList[index].value" style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff" @focus="handleFocus(index, 'judgeList')" @blur="handleBlur(index, 'judgeList')" />
                        <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                        <div style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;" v-show="deviceTableList.judgeList[index].show" >
                          <ul style="list-style: none">
                            <li v-for="(key, judge) of judgeList" :key="key" @mousedown="selectJudge(index, judge)" >
                              {{ judgeList[judge] }}
                              <!-- {{judgeList[judge]}} -->
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td style="position: relative;">
                        <a-input :placeholder="$t('warningForm.valueType')" readOnly v-model="deviceTableList.valueTypeList[index].value" style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff" @focus="handleFocus(index, 'valueTypeList')" @blur="handleBlur(index, 'valueTypeList')" />
                        <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                        <div style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;" v-show="deviceTableList.valueTypeList[index].show" >
                          <ul style="list-style: none">
                            <li v-for="(key, judge) of valueTypeList" :key="key" @mousedown="selectValueType(index, judge)" >
                              {{valueTypeList[judge]}}
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td>
                        <a-input-number id="inputNumber" style="width: 96%; margin: 0 2%;" v-model="deviceTableList.numberList[index].value" />
                      </td>
                      <td style="position: relative; width: 16%;">
                        <a-input :placeholder="$t('warningForm.monitorTime')" readOnly v-model="deviceTableList.duration[index].value" style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff" @focus="handleFocus(index, 'duration')" @blur="handleBlur(index, 'duration')" />
                        <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                        <div style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;" v-show="deviceTableList.duration[index].show" >
                          <ul style="list-style: none">
                            <li v-for="(key, judge) of duration" :key="key" @mousedown="selectDuration(index, judge)" >
                              {{duration[judge]}}
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td style="position: relative;">
                        <a-input :placeholder="$t('warningForm.duration')" readOnly v-model="deviceTableList.period[index].value" style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff" @focus="handleFocus(index, 'period')" @blur="handleBlur(index, 'period')" />
                        <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                        <div style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;" v-show="deviceTableList.period[index].show" >
                          <ul style="list-style: none">
                            <li v-for="judge in period" :key="judge" @mousedown="selectPeriod(index, judge)" >
                              {{judge}}
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td><span :class="{ disabled: deviceTableList.judgeList.length === 1 }" :disabled="deviceTableList.judgeList.length === 1" @click="removeFormTableItem(index, deviceTableList.judgeList.length === 1)">{{ $t('buttons.delete') }}</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <a-form-model-item :label="$t('warningForm.mobile')" :required="!isDelBtnShow">
                <a-button type="primary" @click="addMobile">{{ $t('warningForm.addMobile') }}</a-button>
                <!-- <div class="ant-col ant-form-item-control-wrapper" v-for="(i, index) in mobiles" :key="index" style="margin-bottom: 15px">
                  <div class="wrapper">
                    <a-select option-label-prop="label" @focus="recordMobileIndex(index)" v-model="mobiles[index].reference" @select="handleSelectUsers" notFoundContent="暂无联系人" :getPopupContainer="(triggerNode) => triggerNode.parentNode" placeholder="请选择联系人" dropdownClassName="selectOption">
                      <a-select-option v-for="u in users" :key="u.id" :value="JSON.stringify([u.realName, u.username, u.organizationName])" :label="u.realName">
                        {{ u.realName }} - {{ u.username }} {{ u.organizationName ? '-' + u.organizationName : '' }}
                      </a-select-option>
                    </a-select>
                    <div style="margin: -4px 30px 0" class="ant-form-item-control" :class="{'has-error': i.error}">
                      <span class="ant-form-item-children">
                        <input data-v-30231798="" v-model="mobiles[index].mobile" placeholder="请输入通知手机号" type="text" class="ant-input" @blur="validate(i)">
                      </span>
                      <div class="ant-form-explain" style="white-space: nowrap; position: absolute" v-show="i.error">请输入通知手机号</div>
                    </div>
                    <a-input placeholder="请输入组织" v-model="mobiles[index].organizationName" style="width: 30%; margin-right: 30px" />
                    <div class="ant-form-item-control">
                      <label>是否接收短信：</label>
                      <a-switch v-model="mobiles[index].smsEnabled" />
                    </div>
                    <el-button type="primary" icon="el-icon-delete" circle style="position: relative; right: 120px; height: 40px" :disabled="mobiles.length === 1" @click="mobiles.splice(index, 1)" />
                  </div>
                </div> -->
                <table class="formTable">
                  <thead>
                    <tr>
                      <th>{{ $t('customer.realName') }}</th>
                      <th>{{ $t('warningForm.phoneNumber') }}</th>
                      <th>{{ $t('warningForm.userRole') }}</th>
                      <th>{{ $t('common.organization') }}</th>
                      <th>{{ $t('warningForm.SMSEnable') }}</th>
                      <th>{{ $t('warningForm.warningRecord') }}</th>
                      <th>{{ $t('common.operation') }}</th>
                    </tr>
                  </thead>
                  <tbody style="color: #ccc">
                    <tr v-for="(u, key) in userMap" :key="key">
                      <template v-if="u.editable">
                        <td style="width: 210px"><a-input @blur="f" style="width: 180px" v-model="u.realName" /></td>
                        <td style="width: 210px"><a-input @blur="f" style="width: 190px" v-model="u.username" /></td>
                        <td style="width: 210px"><a-input @blur="f" style="width: 180px" v-model="u.roleName" /></td>
                        <td style="width: 210px"><a-input @blur="f" style="width: 180px" v-model="u.organizationName" /></td>
                      </template>
                      <template v-else>
                        <td style="width: 210px">{{ u.realName }}</td>
                        <td style="width: 210px">{{ u.username }}</td>
                        <td style="width: 210px">{{ u.roleName }}</td>
                        <td style="width: 210px">{{ u.organizationName }}</td>
                      </template>
                      <td>
                        <a-switch :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" @change="f" v-model="u.checked" />
                      </td>
                      <td>
                        <a-switch :checked-children="$t('common.open')" :un-checked-children="$t('common.close')" @change="f" v-model="u.queryEnabled" />
                      </td>
                      <td>
                        <a href="javascript:;" @click="editM(u)">{{ u.editable ? $t('buttons.save') : $t('buttons.edit') }}</a>
                        &nbsp;
                        &nbsp;
                        <a-popconfirm
                          style="padding: 0;"
                          :title="$t('messages.ctrd')"
                          :ok-text="$t('common.okText')"
                          :cancel-text="$t('common.cancelText')"
                          :disabled="u.disabled"
                          @confirm="removeU(u)"
                        >
                          <span :class="{ disabled: u.disabled }">{{ $t('buttons.delete') }}</span>
                        </a-popconfirm>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </a-form-model-item>
            </a-form-model>
            <a-form-model>
              <a-form-model-item>
                <a-button type="primary" @click="submit" :loading="btnLoading">
                  {{ $t('buttons.save') }}
                </a-button>
                <a-button style="margin-left: 10px;" @click="cancel">
                  {{ $t('common.cancelText') }}
                </a-button>
                <a-button type="primary" style="float: right;" @click="submitTemplate">{{ $t('warningForm.submitTemplate') }}</a-button>
              </a-form-model-item>
            </a-form-model>
          </div>
        </div>
        <a-layout-content
          v-show="!isAddOrEdit"
          :style="{ background: '#2F3D4F', padding:'20px', minHeight: '770px' }"
          ref="content"
          class="warning"
        >
          <h3 class="header">
            {{stationName}}
            <a-button v-if="isButtonShow" type="primary" style="float: right; margin-top: 15px" @click="showForm">{{ $t('warningForm.add') }}</a-button>
          </h3>
          <table>
            <thead>
              <tr>
                <th>{{ $t('device.warningID') }}</th>
                <th>{{ $t('device.warningName') }}</th>
                <th>{{ $t('device.warningType') }}</th>
                <th>{{ $t('device.warningDimension') }}</th>
                <th>{{ $t('device.content') }}</th>
                <th>{{ $t('device.mobile') }}</th>
                <th>{{ $t('common.operation') }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-show="!isLoading">
                <tr v-for="warning in warningTableList" :key="warning.id">
                  <td>
                    {{warning.id}}
                  </td>
                  <td>
                    {{warning.name}}
                  </td>
                  <td>
                    {{ $t('device.stationType') }}
                  </td>
                  <td>
                    {{ dimension[warning.dimension][lang] }}
                  </td>
                  <td class="content">
                    <span>{{ warning.noticeContent }}</span>
                  </td>
                  <td>
                    {{warning.noticeMobile}}
                  </td>
                  <td style="padding: 0 10px">
                    <a v-if="isButtonShow" href="javascript:;" @click="toggleToEdit(warning)">{{ $t('buttons.edit') }}</a>
                    &nbsp;
                    &nbsp;
                    <a-popconfirm
                      style="padding: 0"
                      :title="$t('messages.ctrd')"
                      :ok-text="$t('common.okText')"
                      :cancel-text="$t('common.cancelText')"
                      @confirm="removeWarning(warning.id)"
                    >
                      <a href="javascript:;">{{ $t('buttons.delete') }}</a>
                    </a-popconfirm>
                  </td>
                </tr>
              </template>
              <tr v-if="warningTableList.length === 0">
                <td colspan="7" class="noData">{{ $t('device.empty') }}</td>
              </tr>
            </tbody>
          </table>
          <a-pagination
            show-less-items
            v-model="current"
            :total="total"
            :hideOnSinglePage="true"
            @change="handlePageChange"
          />
          <a-spin size="large" class="spin" v-show="isLoading"></a-spin>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import warningApi from '@/api/warning'
import moment from 'moment'
import { deviceApi } from '@/api/station'
import { nanoid } from 'nanoid'
import { getStationOrDeviceWarningList, getWarningTemplateList, deleteWarningTemplate, addWarningTemplate, updateWarningTemplate, addWarning, updateWarning, getWarning, delWarning } from '@/api/warning'
import { getDeviceGroup } from "@/api/device"
import {
  searchCustomerList,
  getCustomerListByCompany,
  addCustomer,
  getCustomerById,
  updateCustomer
} from '@/api/customer'

export default {
  data() {
    return {
      stationName: '',
      warningTableList: [],
      current: 1,
      total: 10,
      isLoading: false,
      device: {},
      users: [],
      dimension: {
        'DEVICE_STATUS': {
          zh: '设备状态',
          en: 'Device Status'
        },
        'DEVICE_PARAMETER': {
          zh: '设备参数',
          en: 'Device Parameter'
        },
        'STATION': {
          zh: '站房',
          en: 'station'        
        }
      },
      btnLoading: false,
      warningTemplateList: [],
      deviceTypeMap: {},
      isAddOrEdit: false,
      form1: {
        name: '',
        dimension: 'STATION',
        strategyConstraint: undefined,
        enabled: false
      },
      form2: {
        noticeContent: ''
      },
      form3: {
        noticeFrequency: undefined,
        warningLevel: undefined,
        noticeCnt: 3,
        recoveryNotice: true
      },
      userMap: {},
      form4: {
        description: '',
        warningRepeat: undefined
      },
      flowmeterList: [],
      elctricityMeterList: [],
      startTime: moment('00:00', 'HH:mm'),
      endTime: moment('00:00', 'HH:mm'),
      mobiles: [
        {
          mobile: '',
          name: undefined,
          smsEnabled: true,
          warningId: null,
          error: false,
          organizationName: '',
          reference: undefined
        }
      ],
      flowmeterList: [],
      elctricityMeterList: [],
      rules: {
        name: [
          {
            required: true,
            message: this.$t('warningForm.swm'),
            trigger: 'blur'
          },
          {
            max: 20,
            message: this.$t('warningForm.n') + 20,
            trigger: 'blur'
          }
        ],
        dimension: [
          {
            required: true,
            message: this.$t('warning.swt')
          }
        ],
        strategyConstraint: [
          {
            required: true,
            message: this.$t('warningForm.sct')
          }
        ],
        noticeContent: [
          {
            required: true,
            message: this.$t('warningForm.enc'),
            trigger: 'blur'
          },
          {
            max: 120,
            message: this.$t('warningForm.n') + 120,
            trigger: 'blur'
          }
        ],
        noticeFrequency: [
          {
            required: true,
            message: this.$t('warningForm.snf')
          }
        ],
        warningLevel: [
          {
            required: true,
            message: this.$t('warningForm.swl')
          }
        ],
        warningRepeat: [
          {
            required: true,
            message: this.$t('warningForm.swr')
          }
        ]
      },
      deviceTableList: {
        judgeList: [{ id: nanoid(), value: '', show: false, flag: undefined }],
        valueTypeList: [{ value: '', show: false, flag: undefined }],
        numberList: [{ value: '' }],
        duration: [{ value: '', show: false, flag: undefined }],
        period: [{ value: '', show: false, flag: undefined}]
      },
      judgeList: {
        EQ: '=',
        NE: '≠',
        GT: '>',
        GE: '≥',
        LT: '<',
        LE: '≤'
      },
      valueTypeList: {
        AVERAGE: this.$t('warningForm.AVERAGE'),
        MAX: this.$t('warningForm.MAX'),
        MIN: this.$t('warningForm.MIN'),
        SUM: this.$t('warningForm.SUM'),
        ORIGIN: this.$t('warningForm.ORIGIN')
      },
      duration: {
        5: '5' + this.$t('warningForm.minutes'),
        20: '20' + this.$t('warningForm.minutes'),
        60: '60' + this.$t('warningForm.minutes')
      },
      period: [1, 2, 3, 4, 5],
      model: undefined,
      isButtonShow: false,
      height: '0px'
    }
  },
  computed: {
    isDelBtnShow () {
      return this.model !== '-' && this.model !== undefined
    },
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    isAddOrEdit (val) {
      if (val) {
        if (this.flowmeterList.length === 0 && this.elctricityMeterList.length === 0) {
          this.$message.warning(this.$t('warningForm.noDevice'))
        }
      }
    },
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  created() {
    let a = this.getAuthorities('/equipment/group')
    this.isButtonShow = !!a.find(auth => auth.code === 'warning:insert')
    this.deviceList = []
  },
  async mounted() {
    await this.getStationInfo()
    this.getWarningTableList()
  },
  methods: {
    translate() {
      this.rules = {
        name: [
          {
            required: true,
            message: this.$t('warningForm.swm'),
            trigger: 'blur'
          },
          {
            max: 20,
            message: this.$t('warningForm.n') + 20,
            trigger: 'blur'
          }
        ],
        dimension: [
          {
            required: true,
            message: this.$t('warning.swt')
          }
        ],
        strategyConstraint: [
          {
            required: true,
            message: this.$t('warningForm.sct')
          }
        ],
        noticeContent: [
          {
            required: true,
            message: this.$t('warningForm.enc'),
            trigger: 'blur'
          },
          {
            max: 120,
            message: this.$t('warningForm.n') + 120,
            trigger: 'blur'
          }
        ],
        noticeFrequency: [
          {
            required: true,
            message: this.$t('warningForm.snf')
          }
        ],
        warningLevel: [
          {
            required: true,
            message: this.$t('warningForm.swl')
          }
        ],
        warningRepeat: [
          {
            required: true,
            message: this.$t('warningForm.swr')
          }
        ]
      }
      this.valueTypeList = {
        AVERAGE: this.$t('warningForm.AVERAGE'),
        MAX: this.$t('warningForm.MAX'),
        MIN: this.$t('warningForm.MIN'),
        SUM: this.$t('warningForm.SUM'),
        ORIGIN: this.$t('warningForm.ORIGIN')
      }
      this.duration = {
        5: '5' + this.$t('warningForm.minutes'),
        20: '20' + this.$t('warningForm.minutes'),
        60: '60' + this.$t('warningForm.minutes')
      }
    },
    moment,
    async getStationInfo() {
      try {
        const { data } = await getDeviceGroup(this.$route.query.id)
        this.stationName = data.name
        this.stationId = data.id
        data.devices.forEach((device) => {
          if (device.type === "LLJ") {
            device.checked = true;
            this.flowmeterList.push(device);
            this.deviceList.push(device);
          } else if (device.type === "DB") {
            device.checked = true;
            this.elctricityMeterList.push(device);
            this.deviceList.push(device);
          }
        })
      } catch(err) {
        console.error(err)
      }
    },
    async getWarningTableList() {
      this.isLoading = true
      try {
        const { data } = await getStationOrDeviceWarningList({
          current: this.current,
          pageSize: 10,
          warningName: '',
          warningDimension: 'STATION',
          targetResource: this.stationId,
          warningType: 'STATION'
        })
        this.total = data.total
        this.warningTableList = data.records.map(r => {
          r.noticeMobile = '';
          (r.mobiles || []).forEach(m => {
            if (m.smsEnabled || m.queryEnabled) {
              r.noticeMobile += m.mobile + ', '
            }
          })
          r.noticeMobile = r.noticeMobile.slice(0, -2)
          return r
        })
        console.log('d')
        this.getCustomerInfo()
      } catch(err) {
        console.error(err)
      } finally {
        this.isLoading = false
      }
    },
    handleFocus (index, type) {
      this.deviceTableList[type][index].show = true
    },
    handleBlur (index, type) {
      this.deviceTableList[type][index].show = false
    },
    selectJudge (index, judge) {
      this.deviceTableList.judgeList[index].value = this.judgeList[judge]
      this.deviceTableList.judgeList[index].flag = judge
    },
    selectValueType(index, type) {
      this.deviceTableList.valueTypeList[index].value = this.valueTypeList[type]
      this.deviceTableList.valueTypeList[index].flag = type
    },
    selectDuration(index, type) {
      this.deviceTableList.duration[index].value = this.duration[type]
      this.deviceTableList.duration[index].flag = type
    },
    selectPeriod(index, type) {
      this.deviceTableList.period[index].value = type
      this.deviceTableList.period[index].flag = type
    },
    addMobile() {
      const id = nanoid()
      this.userMap[id] = {
        checked: false,
        id,
        organizationName: '',
        realName: '',
        roleName: '',
        username: '',
        editable: true
      }
      this.$forceUpdate()
    },
    removeFormTableItem (index, flag) {
      if (flag) {
        return
      }
      for (const key in this.deviceTableList) {
        this.deviceTableList[key].splice(index, 1)
      }
    },
    undo() {
      if(!this.mobiles[this.mobiles.length - 1].mobile && this.mobiles.length === 1) {
        return this.$message.warning(this.$t('warningForm.ealopn'))
      }
      if(!this.mobiles[this.mobiles.length - 1].mobile && !this.mobiles[this.mobiles.length - 1].name) {
        this.mobiles.splice(this.mobiles.length - 1, 1)
      } else {
        this.mobiles[this.mobiles.length - 1].mobile = ''
        this.mobiles[this.mobiles.length - 1].name = ''
        this.$forceUpdate()
      }
    },
    validate(i) {
      if(!i.mobile) {
        i.error = true
        return false
      } else {
        i.error = false
        return true
      }
    },
    async delTemplate () {
      try {
        const { message } = await deleteWarningTemplate(this.model)
        this.$message.success(message)
        await this.showForm()
        for(let i = 1; i < 5; i++) {
          this.$refs[`form${i}`].resetFields()
        }
        this.mobiles = [
          {
            value: '',
            error: false
          }
        ]
        this.form4.description = ''
        this.form1.enabled = false
        this.form4.warningRepeat = undefined
        this.id = undefined
        this.model = undefined
        this.deviceTableList = {
          judgeList: [{ id: nanoid(), value: '', show: false, flag: undefined }],
          valueTypeList: [{ value: '', show: false, flag: undefined }],
          numberList: [{ value: '' }],
          duration: [{ value: '', show: false, flag: undefined }],
          period: [{ value: '', show: false, flag: undefined}]
        }
      } catch (err) {
        console.error(err)
      }
    },
    async submit() {
      let formValid = false
      for(let i = 1; i < 5; i++) {
        this.$refs[`form${i}`].validate(valid => {
          if(valid) {
            formValid = true
          }
        })
      }
      let count = 0
      const mobiles = []
      // for (let j = 0; j < this.mobiles.length; j++) {
      //   const i = this.mobiles[j]
      //   const mobilesValid = this.validate(i)
      //   if(!mobilesValid) {
      //     count++
      //     break
      //   } else {
      //     const id = this.id || i.warningId
      //     mobiles.push({
      //       mobile: i.mobile,
      //       name: i.name,
      //       smsEnabled: true,
      //       warningId: id,
      //       error: false,
      //       organizationName: i.organizationName,
      //       reference: undefined
      //     })
      //   }
      // }
      for (let key in this.userMap) {
        const k = this.userMap[key]
        mobiles.push({
          warningId: this.id,
          smsEnabled: !!k.checked,
          organizationName: this.userMap[key].organizationName,
          mobile: this.userMap[key].username,
          name: this.userMap[key].realName,
          roleName: k.roleName,
          queryEnabled: !!k.queryEnabled
        })
      }
      const warningRepeat = this.form4.warningRepeat.join(',')
      if(count === 0 && formValid) {
        this.btnLoading = true
        const effectiveTime = moment(+this.startTime).format('HH:mm') + '-' + moment(+this.endTime).format('HH:mm')
        if (this.deviceList.length === 0) {
          return this.$message.error(this.$t('placeholder.device'))
        }
        const scope = []
        this.deviceList.forEach(device => {
          if(device.checked) {
            scope.push(device.id)
          }
        })
        const strategies = []
        this.deviceTableList.judgeList.forEach((data, index) => {
          const param = {
            name: '气电比指标',
            code: 'gasElectricRatio',
            valueType: this.deviceTableList.valueTypeList[index].flag,
            condition: this.deviceTableList.judgeList[index].flag,
            targetValue: this.deviceTableList.numberList[index].value + '',
            duration: +this.deviceTableList.duration[index].flag,
            period: this.deviceTableList.period[index].flag
          }
          if(typeof data.id === 'number') {
            param.id = data.id
          }
          strategies.push(param)
        })
        const params = {
          ...this.form1,
          ...this.form2,
          ...this.form3,
          ...this.form4,
          type: 'STATION',
          targetResource: this.stationId,
          scope,
          effectiveTime,
          warningRepeat,
          strategies,
          mobiles
        }
        try {
          if(this.id) {
            params.id = this.id
            const { message } = await updateWarning(params)
            this.$message.success(message)
          } else {
            const { message } = await addWarning(params)
            this.$message.success(message)
          }
          this.cancel()
          this.getWarningTableList()
        } catch(err) {
          console.error(err)
        } finally {
          this.btnLoading = false
        }
      }
    },
    cancel() {
      for(let i = 1; i < 5; i++) {
        this.$refs[`form${i}`].resetFields()
      }
      this.mobiles = [
        {
          mobile: '',
          name: '',
          smsEnabled: true,
          warningId: null,
          error: false
        }
      ]
      this.form4.description = ''
      this.form1.enabled = false
      this.form4.warningRepeat = undefined
      this.id = undefined
      this.isAddOrEdit = false
      this.model = undefined
      this.deviceTableList = {
        judgeList: [{ id: nanoid(), value: '', show: false, flag: undefined }],
        valueTypeList: [{ value: '', show: false, flag: undefined }],
        numberList: [{ value: '' }],
        duration: [{ value: '', show: false, flag: undefined }],
        period: [{ value: '', show: false, flag: undefined}]
      }
      this.getCustomerInfo()
    },
    async removeWarning(id) {
      try {
        await delWarning(id)
        this.getWarningTableList()
      } catch(err) {
        console.error(err)
      }
    },
    oncheckedChange(e, item) {
      item.checked = e.target.checked;
      console.log(this.deviceList);
    },
    async toggleToEdit(warning) {
      this.isAddOrEdit = true
      this.isLoading = true
      this.id = warning.id
      const { data } = await getWarningTemplateList('STATION')
      this.warningTemplateList = data
      try {
        const { data } = await getWarning(this.id)
        this.deviceList.forEach(device => {
          if(data.scope.find(d => d === device.id)) {
            device.checked = true
          } else {
            device.checked = false
          }
        })
        for(let i = 1; i < 5; i++) {
          for(let key in this[`form${i}`]) {
            this[`form${i}`][key] = warning[key]
          }
        }
        const time = warning.effectiveTime.split('-')
        this.startTime = moment(time[0], 'HH:mm')
        this.endTime = moment(time[1], 'HH:mm')
        // this.mobiles = warning.mobiles.map(u => {
        //   u.reference = JSON.stringify([u.name, u.mobile, u.organizationName])
        //   return u
        // })
        warning.mobiles.forEach(m => {
          const u = this.users.find(u => u.username === m.mobile)
          if (u) {
            this.userMap[u.id].checked = m.smsEnabled
            this.userMap[u.id].queryEnabled = m.queryEnabled
          } else {
            this.length++
            const id = nanoid()
            this.userMap[id] = {
              id,
              checked: m.smsEnabled,
              organizationName: m.organizationName,
              realName: m.name,
              roleName: m.roleName,
              username: m.mobile,
              disabled: false,
              queryEnabled: m.queryEnabled
            }
          }
        })
        this.form4.warningRepeat = warning.warningRepeat.split(',')
        const deviceTableList = {
          judgeList: [],
          numberList: [],
          valueTypeList: [],
          duration: [],
          period: []
        }
        data.strategies.forEach(strategie => {
          deviceTableList.judgeList.push({
            value: this.judgeList[strategie.condition],
            flag: strategie.condition,
            show: false
          })
          deviceTableList.numberList.push({
            value: strategie.targetValue
          })
          deviceTableList.valueTypeList.push({
            value: this.valueTypeList[strategie.valueType],
            flag: strategie.valueType,
            show: false
          })
          deviceTableList.duration.push({
            value: this.duration[strategie.duration],
            flag: strategie.duration,
            show: false
          })
          deviceTableList.period.push({
            value: this.period[strategie.period - 1],
            flag: strategie.period,
            show: false
          })
        })
        this.deviceTableList = deviceTableList
      } catch(err) {
        console.error(err)
      }
      this.isLoading = false
    },
    handlePageChange(page) {
      this.current = page
      this.getWarningTableList()
    },
    async showForm () {
      const { data } = await getWarningTemplateList('STATION')
      this.warningTemplateList = data
      this.isAddOrEdit = true
    },
    f() {
      this.$forceUpdate()
    },
    async getCustomerInfo() {
      try {
        const { data } = await getCustomerById(this.$route.query.customerId)
        this.users = []
        const map = {}
        data.followers?.forEach(i => {
          i.roleName = this.$t('common.followers')
          i.checked = false
          i.disabled = true
          map[i.id] = i
        })
        data.salesmen?.forEach(i => {
          i.roleName = this.$t('common.salesMen')
          i.checked = false
          i.disabled = true
          map[i.id] = i
        })
        data.serviceMans?.forEach(i => {
          i.roleName = this.$t('common.serviceMen')
          i.checked = false
          i.disabled = true
          map[i.id] = i
        })
        data.users?.forEach(i => {
          i.roleName = this.$t('common.user')
          i.checked = false
          i.disabled = true
          map[i.id] = i
        })
        for (let key in map) {
          this.users.push(map[key])
        }
        this.userMap = map
        this.originUserMap = JSON.parse(JSON.stringify(map))
        this.length = this.users.length
      } catch {}
    },
    editM(u) {
      u.editable = !u.editable
      this.$forceUpdate()
    },
    removeU(u) {
      if (u.disabled) return
      delete this.userMap[u.id]
      this.$forceUpdate()
    },
    async submitTemplate () {
      let formValid = false
      for(let i = 1; i < 5; i++) {
        this.$refs[`form${i}`].validate(valid => {
          if(valid) {
            formValid = true
          }
        })
      }
      const warningRepeat = this.form4.warningRepeat.join(',')
      if(formValid) {
        const mobiles = []
        for (let key in this.userMap) {
          const k = this.userMap[key]
          if (k.checked || k.queryEnabled) {
            mobiles.push({
              warningId: this.id,
              smsEnabled: !!k.checked,
              organizationName: this.userMap[key].organizationName,
              mobile: this.userMap[key].username,
              name: this.userMap[key].realName,
              roleName: k.roleName,
              queryEnabled: !!k.queryEnabled
            })
          }
        }
        const effectiveTime = moment(+this.startTime).format('HH:mm') + '-' + moment(+this.endTime).format('HH:mm')
        const scope = []
        this.deviceList.forEach(device => {
          if(device.checked) {
            scope.push(device.id)
          }
        })
        const strategy = []
        this.deviceTableList.judgeList.forEach((data, index) => {
          const param = {
            name: '气电比指标',
            code: 'gasElectricRatio',
            valueType: this.deviceTableList.valueTypeList[index].flag,
            condition: this.deviceTableList.judgeList[index].flag,
            targetValue: this.deviceTableList.numberList[index].value + '',
            duration: +this.deviceTableList.duration[index].flag,
            period: this.deviceTableList.period[index].flag
          }
          if(typeof data.id === 'number') {
            param.id = data.id
          }
          strategy.push(param)
        })
        const params = {
          ...this.form1,
          ...this.form2,
          ...this.form3,
          ...this.form4,
          type: 'STATION',
          targetResource: this.stationId,
          scope,
          effectiveTime,
          warningRepeat,
          strategy,
          targetType: 'STATION',
          sort: 1,
          mobiles
        }
        try {
          if (this.model && typeof this.model === 'number') {
            params.id = this.model
            const { message } = await updateWarningTemplate(params)
            this.$message.success(message)
          } else {
            console.log(this.model);
            const { message } = await addWarningTemplate(params)
            this.$message.success(message)
          }
          this.showForm()
        } catch (err) {
          console.error(err)
        }
      }
    },
    addFormTableItem() {
      this.deviceTableList.judgeList.push({
        id: nanoid(),
        value: '',
        show: false
      })
      this.deviceTableList.valueTypeList.push({
        value: '',
        show: false
      })
      this.deviceTableList.duration.push({
        value: '',
        show: false
      })
      this.deviceTableList.period.push({
        value: '',
        show: false
      })
      this.deviceTableList.numberList.push({
        value: ''
      })
    },
    undoData () {
      let flag = false
      for (let key in this.deviceTableList) {
        if (this.deviceTableList[key].at(-1).value) {
          flag = true
          this.deviceTableList[key].at(-1).value = ''
        }
      }
      if (!flag) {
        for (let key in this.deviceTableList) {
          this.deviceTableList[key].pop()
        }
      }
    },
    handleModelChange (value) {
      this.userMap = JSON.parse(JSON.stringify(this.originUserMap))
      if (value !== '-') {
        const warning = this.warningTemplateList.find(warn => warn.id === value)
        for(let i = 1; i < 5; i++) {
          for(let key in this[`form${i}`]) {
            this[`form${i}`][key] = warning[key]
          }
        }
        const time = warning.effectiveTime.split('-')
        this.startTime = moment(time[0], 'HH:mm')
        this.endTime = moment(time[1], 'HH:mm')
        warning.mobiles.forEach(m => {
          const u = this.users.find(u => u.username === m.mobile)
          if (u) {
            this.userMap[u.id].checked = m.smsEnabled
            this.userMap[u.id].queryEnabled = m.queryEnabled
          } else {
            this.length++
            const id = nanoid()
            this.userMap[id] = {
              id,
              checked: true,
              organizationName: m.organizationName,
              realName: m.name,
              roleName: m.roleName,
              username: m.mobile,
              queryEnabled: m.queryEnabled
            }
          }
        })
        this.form4.warningRepeat = warning.warningRepeat.split(',')
        if (warning.strategy && warning.strategy.length > 0) {
          if(warning.strategy?.[0].name === '离线指标') {
            return
          }
          const deviceTableList = {
            dataList: [],
            judgeList: [],
            numberList: [],
            valueTypeList: [],
            duration: [],
            period: []
          }
          warning.strategy.forEach(strategie => {
            deviceTableList.dataList.push({
              id: strategie.id,
              dataName: strategie.name,
              code: strategie.code,
              show: false
            })
            deviceTableList.judgeList.push({
              value: this.judgeList[strategie.condition],
              flag: strategie.condition,
              show: false
            })
            deviceTableList.numberList.push({
              value: strategie.targetValue
            })
            deviceTableList.valueTypeList.push({
              value: this.valueTypeList[strategie.valueType],
              flag: strategie.valueType,
              show: false
            })
            deviceTableList.duration.push({
              value: this.duration[strategie.duration],
              flag: strategie.duration,
              show: false
            })
            deviceTableList.period.push({
              value: this.period[strategie.period - 1],
              flag: strategie.period,
              show: false
            })
          })
          this.deviceTableList = deviceTableList
        }
      } else {
        for(let i = 1; i < 5; i++) {
          this.$refs[`form${i}`].resetFields()
        }
        this.mobiles = [
          {
            mobile: '',
            name: '',
            smsEnabled: true,
            warningId: null,
            error: false
          }
        ]
        this.form4.description = ''
        this.form1.enabled = false
        this.form4.warningRepeat = undefined
        this.id = undefined
        this.model = undefined
        this.deviceTableList = {
          judgeList: [{ id: nanoid(), value: '', show: false, flag: undefined }],
          valueTypeList: [{ value: '', show: false, flag: undefined }],
          numberList: [{ value: '' }],
          duration: [{ value: '', show: false, flag: undefined }],
          period: [{ value: '', show: false, flag: undefined}]
        }
      }
    },
    recordMobileIndex(index) {
      this.selectedIndexOfMobiles = index
    },
    handleSelectUsers(v) {
      const value = JSON.parse(v)
      this.mobiles[this.selectedIndexOfMobiles].mobile = value[1]
      this.mobiles[this.selectedIndexOfMobiles].name = value[0]
      this.mobiles[this.selectedIndexOfMobiles].organizationName = value[2] || ''
      console.log(this.mobiles);
    }
  }
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.ant-layout-has-sider {
  margin: 20px;
}
.stationName {
  height: auto;
  background-color: #001529;
  margin: 0;
  padding: 0;
  color: #fff;
  line-height: 40px;
  font-size: 22px;
  padding-left: 24px;
}
.warning {
  position: relative;
  background-color: #2F3D4F;
  overflow: auto;
  min-height: 770px;
  tbody ul {
    width: 100%;
    li {
      padding: 0 10px;
      height: 30px;
      line-height: 30px;
    }
    li:hover {
      background-color: #A7ADB5;
    }
  }
  .device {
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    div {
      width: 48%;
      background-color: #212d3f;
    }
    .head {
      color: #f8fced;
      font-size: 18px;
      padding: 10px;
    }
    .border {
      width: 100%;
      clear: both;
      border-bottom: 1px solid #1976cf;
    }
    .body {
      width: 100%;
    }
    .body ul li {
      list-style: none;
      float: left;
      margin: 10px 0 10px 10px;
      padding: 0;
      width: 150px;
      /* overflow: hidden; */
      height: 24px;
      font-size: 16px;
      background-color: #4a90e2;
      color: #f8fced;
      text-align: center;
      .device_name {
        color: #fff;
        float: left;
        /* margin-left: 5px; */
        width: 120px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      input[type^="checkbox"] {
        width: 18px;
        height: 18px;
        vertical-align: middle;
      }
    }
  }
  form {
    width: 90%;
    margin: 20px auto;
    h3.tableTitle {
      font-size: 15px;
      color: #bfbfbf;
      margin-bottom: 15px;
    }
    input.ant-input {
      color: #fff;
      padding: 0 10px;
    }
  }
  .spin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
  }
  .header {
    width: 95%;
    margin: auto;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    color: #F8FCED;
    border-bottom: 1px solid #1976CF;
  }
  table {
    width: 100%;
    border: 1px solid #4A5665;
    color: #A7ADB5;
    margin-top: 24px;
    margin-bottom: 24px;
    th,
    td {
      height: 60px;
      text-align: center;
    }
    th {
      border-right: 1px solid #5B6574;
      background-color: #485464;
      padding: 0 10px;
    }
    td {
      border-top: 1px solid #445161;
      border-right: 1px solid #445161;
      &.content {
        width: 300px;
        overflow: hidden;
        box-sizing: border-box;
        span {
          display: block;
          max-width: 280px;
          padding-left: 10px;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .formTable th,
  .formTable td {
    height: 40px;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    .ant-form-item {
      width: 30%
    }
  }
}
.warning .ant-input,
.warning .ant-select-selection__placeholder.ant-input,
.warning .ant-calendar-picker-input.ant-input {
  background-color: #2F3D4F;
}
.warning .ant-input[data-v-020d5318], .warning .ant-select-selection__placeholder.ant-input[data-v-020d5318], .warning .ant-calendar-picker-input.ant-input[data-v-020d5318] {
  padding: 0 10px;
  color: #fff;
}
.ant-col .wrapper {
  display: flex;
  justify-content: space-between;
  div {
    width: 30%;
    label {
      color: #bfbfbf;
    }
  }
}
span.disabled {
  color: #999;
  cursor: not-allowed !important;
}
.formTable span:not(.disabled) {
  color: #1890ff;
  cursor: pointer;
}
</style>